import { DefaultColumnOptions } from "../../../hooks/useDataGrid/options";

export const Columns = [
  { ...DefaultColumnOptions.Id, sort: "asc" },
  {
    headerName: "First Name",
    field: "firstName",
    tooltipField: "firstName",
  },
  {
    headerName: "Last Name",
    field: "lastName",
    tooltipField: "lastName",
  },
  {
    headerName: "Email",
    field: "email",
    tooltipField: "email",
  },
  {
    headerName: "Mobile Number",
    field: "mobileNumber",
    tooltipField: "mobileNumber",
  },
  {
    headerName: "Candidate Type",
    field: "candidateType",
    sortable: false,
    tooltipField: "candidateType",
    headerTooltip: "Candidate Type",
  },
  {
    headerName: "ATS ID",
    field: "atsLookupId",
    sortable: false,
    tooltipField: "atsLookupId",
    headerTooltip: "ATS ID",
  },
  {
    headerName: "Current Title",
    field: "currentTitle",
    tooltipField: "currentTitle",
  },
  {
    headerName: "Blacklist ?",
    field: "isBlacklistDisplay",
    tooltipField: "isBlacklistDisplay",
  },
];
